
import { IIdsRequest } from "../../models/request/base/IIdsRequest"
import { IDotDanhGiaLop } from "../../models/response/danh-gia/IDotDanhGiaLop"
import { apiClient } from "../apiClient"
import { DOT_DANH_GIA_RESOURCE } from "./dotDanhGiaApi"

export const DOT_DANH_GIA_LOP_RESOURCE = "dot-danh-gia/{id}/lop"
export const dotDanhGiaLopApi = {
    SelectByDot: (dotDanhGiaId: number) => apiClient.get(`${DOT_DANH_GIA_RESOURCE}/${dotDanhGiaId}/lop`),
    Inserts: (dotDanhGiaId: number, payload: IDotDanhGiaLop[]) => apiClient.post(`${DOT_DANH_GIA_RESOURCE}/${dotDanhGiaId}/lop`, payload),
    Updates: (dotDanhGiaId: number, payload: IDotDanhGiaLop[]) => apiClient.put(`${DOT_DANH_GIA_RESOURCE}/${dotDanhGiaId}/lop`, payload),
    Deletes: (dotDanhGiaId: number, payload: IIdsRequest) => apiClient.post(`${DOT_DANH_GIA_RESOURCE}/${dotDanhGiaId}/lop/deletes`, payload),
}